
export const TimeFrameOptions = ['30 min', '1 hr', '2 hr', '3 hr', '6 hr', '12 hr']
export const TimeFrameInMinutes = {
    '30 min': 30,
    '1 hr': 60,
    '2 hr': 120,
    '3 hr': 180,
    '6 hr': 360,
    '12 hr': 720
}

export const OrbitStartOptions = ['Start Time', 'Sunlit']